import { createColumnHelper } from "@tanstack/react-table";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ReactTable, useSelectedDealer } from "components";
import { useRegisterNavAction } from "hooks";
import "modules/AgreementsDashboard/components/AgreementsTable/AgreementsTable.scss";
import { useAgreementsQuery } from "modules/AgreementsDashboard/hooks";

import type { CommunicationAgreement } from "models";

type AgreementsTableProps = {
  handleShowEditAgreementsModal: (id: number) => void;
};

const columnHelper = createColumnHelper<CommunicationAgreement>();

export const AgreementsTable = ({ handleShowEditAgreementsModal }: AgreementsTableProps) => {
  const { t } = useTranslation();

  const { selectedDealer } = useSelectedDealer();
  const { data: agreements, isFetching: isFetchingAgreements, refetch: refetchAgreements } = useAgreementsQuery();

  useRegisterNavAction(refetchAgreements);

  useEffect(() => {
    if (selectedDealer?.id) refetchAgreements();
  }, [selectedDealer?.id]);

  const columns = useMemo(
    () => [
      columnHelper.accessor(row => row, {
        id: "name",
        header: () => <span className="header-title">{t("v8_name", "Name")}</span>,
        size: 250,
        cell: info => <span className="text-ellipsis">{info.row.original.name}</span>
      }),

      columnHelper.accessor(row => row, {
        id: "text",
        header: () => <span className="header-title">{t("v8_text", "Text")}</span>,
        size: 250,
        cell: info => (
          <div className="text-container">
            <span className="text-ellipsis">{info.row.original.text}</span>
          </div>
        )
      })
    ],
    [t]
  );

  return (
    <div className="AgreementsTable">
      <ReactTable
        isFetching={isFetchingAgreements || !selectedDealer}
        columns={columns}
        data={agreements}
        onRowClick={(agreement: CommunicationAgreement) => handleShowEditAgreementsModal(agreement.id)}
      />
    </div>
  );
};
